import { useRef, useCallback } from "react";

export const useInfiniteScroll = (
	isFetching: boolean,
	hasNextPage: boolean,
	fetchNextPage: () => void,
	scrollRootId?: string,
) => {
	const observer = useRef<IntersectionObserver | null>(null);
	const calledRef = useRef(false);

	const lastElementRef = useCallback(
		(node: HTMLElement | null) => {
			if (observer.current) observer.current.disconnect();

			const rootEl = scrollRootId ? document.getElementById(scrollRootId) : null;

			observer.current = new IntersectionObserver(
				entries => {
					const entry = entries[0];

					const shouldFetch =
						entry.isIntersecting && entry.intersectionRatio > 0 && hasNextPage && !isFetching && !calledRef.current;

					if (shouldFetch) {
						calledRef.current = true;
						fetchNextPage();
					}
				},
				{
					root: rootEl,
					rootMargin: "100px",
					threshold: 0.1,
				},
			);

			if (node) {
				observer.current.observe(node);
				calledRef.current = false;
			}
		},
		[isFetching, hasNextPage, fetchNextPage, scrollRootId],
	);

	return lastElementRef;
};
